export default {
  state: {
    allGameList: [],
    ExgameList: [],
    resetIndex: 0, // 觸發刷新
    resetExgame: 0 // 外站遊戲觸發刷新
  },
  actions: {
    setAllGame ({ commit }, value) {
      commit('In_allgame', value)
    },
    setAllGameReset ({ commit }) {
      commit('plusResetIndex')
    },
    setExgame ({ commit }, value) {
      commit('setExgame', value)
    },
    updateExgameReset ({ commit }) {
      commit('updateExgameReset')
    },
  },
  mutations: {
    In_allgame (state, value) {
      state.allGameList = value
    },
    plusResetIndex (state) {
      state.resetIndex += 1
    },
    setExgame (state, value) {
      state.ExgameList = value
    },
    updateExgameReset (state, value) {
      state.resetExgame += 1
    },
  },
  getters: {
    getAllGame: state => state.allGameList,
    getAllGameResetIndex: state => state.resetIndex,
    getExgameList: state => state.ExgameList,
    getResetExgame: state => state.resetExgame,
  }
}